import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, obj = user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    client
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    if (data.needsVerification) return data;
    setUser(data);
    return data;
  };
  const register = async (payload) => {
    const { data } = await client.post("/auth/register", payload);
    if (data.needsVerification) return data;
    setUser(data);
    return data;
  };
  const verifyEmail = async (email, code) => {
    const { data } = await client.post("/auth/verify", { email, code });
    setUser(data);
    return data;
  };
  const resendCode = async (email) => {
    const { data } = await client.post("/auth/resend-code", { email });
    return data;
  };
  const logout = async () => {
    await client.post("/auth/logout");
    setUser(false);
  };
  const refresh = async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, verifyEmail, resendCode, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
